// extracted by css-extract-rspack-plugin
var _1 = "j";
var _2 = "v0";
var _3 = "v1";
var _4 = "v8";
var _5 = "vz";
var _6 = "v2";
var _7 = "v4";
var _8 = "v5";
var _9 = "v3";
var _a = "v7";
var _b = "v6";
export { _1 as "buttonV2Component", _2 as "darkBlueRoundAppearance", _3 as "darkBueWithMagentaHoverAppearance", _4 as "disabledAppearance", _5 as "magentaAppearance", _6 as "magentaRoundAppearance", _7 as "transparentDarkBlueAppearance", _8 as "transparentLightBlueAppearance", _9 as "transparentMagentaAppearance", _a as "transparentRoundGrayBorderAppearance", _b as "transparentRoundMagentaBorderAppearance" }
